import { render } from "./TrainingBlocExtentSubscriptionButton.vue?vue&type=template&id=5c955044"
import script from "./TrainingBlocExtentSubscriptionButton.vue?vue&type=script&lang=js"
export * from "./TrainingBlocExtentSubscriptionButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__